(function($) {
	$(document).ready(function(){

		$('.accordion__header').on('click', function(){
			$(this).next().toggleClass('open');
			$(this).toggleClass('open');
		});

	});
})(jQuery); // Fully reference jQuery after this point.